// extracted by mini-css-extract-plugin
export default {"searchResBlock":"ResultsCount_searchResBlock__1XsRL"};